import { getToken } from "../../helpers/common";
import * as apiService from "../api";
import * as API_URL from "../../constants/api";

export const fetchGlobalSettings = async () => {
  try {
    const token = getToken();
    return await apiService.post(API_URL.GLOBAL_SETTING + "/fetch", {}, token);
  } catch (err) {
    console.log("Error in fetchGlobalSettings service :", err);
    return { success: false, message: "Internal Server Error", data: null };
  }
};

export const updateGlobalSetting = async (payload) => {
  try {
    const token = getToken();
    return await apiService.put(
      API_URL.GLOBAL_SETTING + "/update",
      payload,
      token
    );
  } catch (err) {
    console.log("Error in updateGlobalSetting service :", err);
    return { success: false, message: "Internal Server Error", data: null };
  }
};
